import { render } from "./file.upload.vue?vue&type=template&id=1c24d448"
import script from "./file.upload.vue?vue&type=script&lang=js"
export * from "./file.upload.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__